import $ from 'jquery'
import 'bootstrap-sass/assets/javascripts/bootstrap.js'

$(document).ready(function () {
  $('#coronaModal').modal('show')
})
